import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';

import { BaseContext } from 'context/base.context';
import { RoutePath } from 'routes/route-path.constant';

import { useSaveAnswers } from 'hooks/use-save-answers.hook';
import { useLocalStorage } from 'hooks/use-local-storage.hook';

import { LocalStorageKeys } from 'constants/local-storage';
import { TypographyVariants } from 'constants/typography-variants';

import { Typography } from 'components/typography';
import { ChoiceButton, ChoiceType } from 'components/choice-button';

export enum WORKOUTS_ANSWERS { NOT = 'notAtAll', ONE = 'oneTwo', THREE = 'three', MORE = 'moreThanThree' }

export const Workouts = () => {
    const { t } = useTranslation();
    const saveAnswers = useSaveAnswers();

    const { pageConfiguration } = useContext(BaseContext);

    const pageKey = LocalStorageKeys[RoutePath.Workouts];

    const { pageValue, setPageValue }: any = useLocalStorage({
        key: pageKey,
        defaultValue: '',
    });

    const handleClick = (answer: ChoiceType) => {
        saveAnswers({
            key: pageKey,
            itemQuestion: { question: t('workouts-title'), value: t(answer.value) },
        });
        setPageValue(answer.key);

        pageConfiguration.handleOnPageComplete(answer.key);
    };

    const choices: ChoiceType[] = [
        { key: WORKOUTS_ANSWERS.NOT, value: 'workouts-option-notAtAll' },
        { key: WORKOUTS_ANSWERS.ONE, value: 'workouts-option-oneTwo' },
        { key: WORKOUTS_ANSWERS.THREE, value: 'workouts-option-three' },
        { key: WORKOUTS_ANSWERS.MORE, value: 'workouts-option-moreThanThree' },
    ];

    return (
        <>
            <Typography variant={TypographyVariants.h1}>
                {t('workouts-title')}
            </Typography>

            {choices.map((v: ChoiceType) => (
                <ChoiceButton
                    key={v.key}
                    center={true}
                    selected={v.key === pageValue}
                    typographyText={t(v.value)}
                    onClick={() => handleClick(v)}
                />
            ))}
        </>
    );
};
